import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash-es';
import Button from 'reactstrap/lib/Button';
import { useToggle } from 'site-modules/shared/hooks/use-toggle';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { VisitorEntities } from 'client/data/models/visitor';
import { DEFAULT_TRIM_CTA_NAME } from 'site-modules/shared/constants/new-core';
import { LEAD_FORMS_CREATIVE_ID } from 'site-modules/shared/components/lead-form/unified-lead-form/constants/creative-ids';
import { isUnknownZip } from 'site-modules/shared/utils/location';
import { getLeadFormCreativeId } from 'site-modules/shared/components/lead-form/utils/lead-form-creative-id';
import { TransparentPricingLeadFormDrawer } from 'site-modules/shared/components/lead-form/transparent-pricing-lead-form/transparent-pricing-lead-form-drawer';

function LeadFormButtonUI({
  style,
  fallbackFragment = null,
  showLeadForm = false,
  bestDealPrice = null,
  visitorLocation = null,
  btnColor = 'primary-b',
  pageName = null,
  isMobile = false,
}) {
  const [isLeadFormOpen, toggleLeadFormOpen] = useToggle(false);
  const isInternational = isUnknownZip(visitorLocation);
  const { id, trimName, trim, makeName, modelName, year } = style;
  const { zipCode, city } = visitorLocation;
  const ctaLabel = isInternational ? 'See Local Pricing' : DEFAULT_TRIM_CTA_NAME;

  const leadFormCreativeId = getLeadFormCreativeId({
    isNewVin: true,
    pageNameLegacy: pageName,
    formName: LEAD_FORMS_CREATIVE_ID.COMPARATOR_CARD,
  });

  return (
    <Fragment>
      {showLeadForm || isInternational ? (
        <Button
          onClick={toggleLeadFormOpen}
          size="lg"
          color={btnColor}
          className="text-transform-none fw-normal px-1 py-0_5"
          data-tracking-id="view_pricing_details"
        >
          {ctaLabel}
          <span className="visually-hidden">
            &nbsp;for {year} {makeName} {modelName}
          </span>
        </Button>
      ) : (
        fallbackFragment
      )}

      <TransparentPricingLeadFormDrawer
        isOpen={isLeadFormOpen}
        onDrawerToggle={toggleLeadFormOpen}
        params={{
          styleId: id,
          trim: trim || trimName,
          vehicle: style,
          zipCode,
          city,
        }}
        options={{
          isMobile,
          bestDealPrice,
          creativeId: leadFormCreativeId,
        }}
        creativeId={leadFormCreativeId}
      />
    </Fragment>
  );
}

LeadFormButtonUI.propTypes = {
  style: VehicleEntities.Style.isRequired,
  fallbackFragment: PropTypes.node,
  bestDealPrice: PropTypes.number,
  visitorLocation: VisitorEntities.Location,
  btnColor: PropTypes.string,
  pageName: PropTypes.string,
  showLeadForm: PropTypes.bool,
  isMobile: PropTypes.bool,
};

const mapStateToProps = state => ({
  visitorLocation: get(state, 'visitor.location'),
  pageName: get(state, 'pageContext.legacy.pageName') || get(state, 'pageContext.page.name'),
});

export const LeadFormButton = connect(mapStateToProps)(LeadFormButtonUI);
